module.exports = "data:text/x-markdown;base64,VGhpcyBlbGV2YXRvciB3b24ndCBsZXQgeW91IHJlYWNoIHRoZSB0b3Agb2YgeW91ciBidWlsZGluZy4gUmlnaHQ/CgojIyMjIyBUaGluZ3MgdGhhdCBtaWdodCBoZWxwOgoqIFNvbWV0aW1lcyBzb2xpZGl0eSBpcyBub3QgZ29vZCBhdCBrZWVwaW5nIHByb21pc2VzLgoqIFRoaXMgYEVsZXZhdG9yYCBleHBlY3RzIHRvIGJlIHVzZWQgZnJvbSBhIGBCdWlsZGluZ2Au"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/elevator.md
// module id = 1367
// module chunks = 0